export { default } from '@white-label-store/deposits';
export * from '@white-label-store/deposits';
